var map = {
	"./AD.svg": "e7d7",
	"./AE.svg": "8bd7",
	"./AF.svg": "39b3",
	"./AG.svg": "99d0",
	"./AI.svg": "da62",
	"./AL.svg": "3a85",
	"./AM.svg": "c594",
	"./AN.svg": "e018",
	"./AO.svg": "e1ed",
	"./AQ.svg": "8513",
	"./AR.svg": "04a6",
	"./AT.svg": "3968",
	"./AU.svg": "8f49",
	"./AW.svg": "8122",
	"./AX.svg": "7cb0",
	"./AZ.svg": "e1a1",
	"./BA.svg": "f757",
	"./BB.svg": "5647",
	"./BD.svg": "4acf",
	"./BE.svg": "ffda",
	"./BF.svg": "07a4",
	"./BG.svg": "40ab",
	"./BH.svg": "322e",
	"./BI.svg": "dd72",
	"./BJ.svg": "6a0c",
	"./BM.svg": "0b16",
	"./BN.svg": "af7f",
	"./BO.svg": "0582",
	"./BR.svg": "b8d9",
	"./BS.svg": "d995",
	"./BT.svg": "1193",
	"./BW.svg": "443f",
	"./BY.svg": "d358",
	"./BZ.svg": "dfe6",
	"./CA.svg": "301b",
	"./CAF.svg": "e7bc",
	"./CAS.svg": "1201",
	"./CD.svg": "3cd6",
	"./CEU.svg": "aaae",
	"./CF.svg": "7fdb",
	"./CG.svg": "ffe7",
	"./CH.svg": "35e5",
	"./CI.svg": "8232",
	"./CL.svg": "a249",
	"./CM.svg": "b4e6",
	"./CN.svg": "5b63",
	"./CNA.svg": "c474",
	"./CO.svg": "2c40",
	"./COC.svg": "847e",
	"./CR.svg": "c078",
	"./CSA.svg": "c1a2",
	"./CU.svg": "0f09",
	"./CV.svg": "68ad",
	"./CY.svg": "6b49",
	"./CZ.svg": "9b78",
	"./DE.svg": "0eb1",
	"./DJ.svg": "1edb",
	"./DK.svg": "af43",
	"./DM.svg": "1455",
	"./DO.svg": "1b0e",
	"./DZ.svg": "496f",
	"./EC.svg": "368b",
	"./EE.svg": "e7df",
	"./EG.svg": "de07",
	"./ER.svg": "4a89",
	"./ES.svg": "439c",
	"./ET.svg": "e1c5",
	"./EU.svg": "9302",
	"./FI.svg": "e9dc",
	"./FJ.svg": "7065",
	"./FK.svg": "0a91",
	"./FM.svg": "ce73",
	"./FR.svg": "10b2",
	"./GA.svg": "11f7",
	"./GB.svg": "e199",
	"./GD.svg": "87b3",
	"./GE.svg": "797f",
	"./GG.svg": "baa3",
	"./GH.svg": "2051",
	"./GI.svg": "ff62",
	"./GM.svg": "c0ba",
	"./GN.svg": "ee7f",
	"./GQ.svg": "72b3",
	"./GR.svg": "1136",
	"./GT.svg": "e0c4",
	"./GW.svg": "1674",
	"./GY.svg": "4a0b",
	"./HK.svg": "e398",
	"./HN.svg": "2808",
	"./HR.svg": "e4d7",
	"./HT.svg": "6e88",
	"./HU.svg": "531d",
	"./ID.svg": "c908",
	"./IE.svg": "467f8",
	"./IM.svg": "9df9",
	"./IN.svg": "5ed2",
	"./IQ.svg": "1c19",
	"./IR.svg": "b2ca",
	"./IS.svg": "6e1a",
	"./IT.svg": "f320",
	"./JE.svg": "8836",
	"./JM.svg": "f7d4",
	"./JO.svg": "f137",
	"./JP.svg": "1282",
	"./KE.svg": "a74f",
	"./KG.svg": "cd72",
	"./KH.svg": "8adc",
	"./KM.svg": "64a2",
	"./KN.svg": "49df",
	"./KP.svg": "3693",
	"./KR.svg": "f658",
	"./KW.svg": "06dd",
	"./KY.svg": "3377",
	"./KZ.svg": "f483",
	"./LA.svg": "6e9b",
	"./LB.svg": "f478",
	"./LC.svg": "99a2",
	"./LI.svg": "8bfc",
	"./LK.svg": "62ad",
	"./LR.svg": "800c",
	"./LS.svg": "3eb2",
	"./LT.svg": "b749",
	"./LU.svg": "a5ec",
	"./LV.svg": "6cfc",
	"./LY.svg": "d939",
	"./MA.svg": "8f2d",
	"./MC.svg": "151f",
	"./MD.svg": "60bc",
	"./ME.svg": "2051e",
	"./MG.svg": "d195",
	"./MK.svg": "bd57",
	"./ML.svg": "f438",
	"./MM.svg": "53ec",
	"./MN.svg": "8530",
	"./MO.svg": "3ab3",
	"./MR.svg": "65f3",
	"./MS.svg": "5b2f",
	"./MT.svg": "b255",
	"./MU.svg": "6721",
	"./MV.svg": "d116",
	"./MW.svg": "9d67",
	"./MX.svg": "784d",
	"./MY.svg": "30f3",
	"./MZ.svg": "46a5",
	"./NA.svg": "1848",
	"./NE.svg": "5180",
	"./NG.svg": "9456",
	"./NI.svg": "9a96",
	"./NL.svg": "a277",
	"./NO.svg": "4b14",
	"./NP.svg": "c36a",
	"./NZ.svg": "9eb1",
	"./OM.svg": "d1e7b",
	"./PA.svg": "8238",
	"./PE.svg": "cbac",
	"./PF.svg": "bff2",
	"./PG.svg": "7ce9",
	"./PH.svg": "a70e",
	"./PK.svg": "87c0",
	"./PL.svg": "6e70",
	"./PR.svg": "a833",
	"./PT.svg": "31f1",
	"./PW.svg": "a7c6",
	"./PY.svg": "8410",
	"./QA.svg": "8dfc",
	"./RO.svg": "9aa4",
	"./RS.svg": "b2f9",
	"./RU.svg": "b094",
	"./RW.svg": "8355",
	"./SA.svg": "a387",
	"./SB.svg": "960e",
	"./SC.svg": "47ef",
	"./SD.svg": "af96",
	"./SE.svg": "9634",
	"./SG.svg": "cc11",
	"./SH.svg": "58ab",
	"./SI.svg": "3de7",
	"./SK.svg": "3350",
	"./SL.svg": "a51e",
	"./SM.svg": "2490",
	"./SN.svg": "e246",
	"./SO.svg": "1641",
	"./SR.svg": "ba9e",
	"./ST.svg": "2a8f",
	"./SV.svg": "4c6f",
	"./SY.svg": "3814",
	"./SZ.svg": "0fba",
	"./TC.svg": "5633",
	"./TD.svg": "3442",
	"./TG.svg": "40b9",
	"./TH.svg": "9e22",
	"./TJ.svg": "69cb",
	"./TL.svg": "4ca0",
	"./TM.svg": "8ea9",
	"./TN.svg": "a575",
	"./TO.svg": "4f5a",
	"./TR.svg": "fe65",
	"./TT.svg": "b1bf",
	"./TW.svg": "5dec",
	"./TZ.svg": "d9af",
	"./UA.svg": "7cb2",
	"./UG.svg": "b4cf",
	"./US.svg": "046c",
	"./UY.svg": "7a03",
	"./UZ.svg": "05e2",
	"./VC.svg": "f18f",
	"./VE.svg": "0ba7",
	"./VG.svg": "ad82",
	"./VN.svg": "e458",
	"./VU.svg": "5be3",
	"./WS.svg": "fe05",
	"./WW.svg": "4b00",
	"./YE.svg": "6bb3",
	"./ZA.svg": "9461",
	"./ZM.svg": "d701",
	"./ZW.svg": "c141",
	"./_.svg": "1eda"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b292";